module.exports = __webpack_public_path__ + "img/edge_divers_marches.51ce75c7.svg";